export const setCollpasedSideNavbarToggle = (param) => ({
  type: 'SET_SIDE_NAVBAR_COLLAPSED_VIEW',
  payload: { sideNavbarCollapsedView: param },
});
